import { TenantTemplateRouterCore } from "@components/tenant/TenantTemplateRouter";
import DefaultInvoicePrint from "./default";

const templates = import.meta.glob<{ default: React.ComponentType<any> }>(
  "/src/pages/user/BuyInvoices/Print/templates/*/index.tsx"
);

type BuyInvoicePrintProps = {
};

export default function BuyInvoicePrint(props: BuyInvoicePrintProps) {
  return (
    <TenantTemplateRouterCore<BuyInvoicePrintProps>
      templates={templates}
      DefaultComponent={DefaultInvoicePrint}
      passProps={props}
    />
  );
}